import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastController } from '@ionic/angular';

/*  AUTOMATIKUS KRÉTA-SZINKRON – a KRÉTA naplózás oldal kártyája.
 *
 *  A csoporttagság és az órarend KRÉTA-átvétele eddig kézzel indult; itt kapcsolható be,
 *  hogy naponta a megadott időpontokban (alapból 02:30 és 12:30) magától fusson
 *  (backend: kreta-utemezo.js). Ugyanitt látszik a már automatikus KRÉTA-feladatok
 *  (naplózás, e-Ügyintézés, feljegyzés) állapota, és a „KRÉTA-ban átvezetendő” lista:
 *  a kézi, a KRÉTÁ-tól eltérő csoporttagságok, amelyeket az átvétel nem ír vissza,
 *  amíg a KRÉTA nem egyezik.
 */
@Component({
  selector: 'app-kreta-utemezo-kartya',
  templateUrl: './kreta-utemezo-kartya.component.html',
  styleUrls: ['./kreta-utemezo-kartya.component.scss'],
})
export class KretaUtemezoKartyaComponent implements OnChanges, OnDestroy {
  @Input() intezmeny = '';
  private readonly base = '/api/kreta-utemezo';
  adat: any = null;
  hiba = '';
  form: any = { tagsag_enabled: false, orarend_enabled: false, tanuloadat_enabled: false, idopontok: '02:30, 12:30', horizont_nap: 14,
                atvetel_hatar: '2026-10-31', admin_allomany: '' };
  mentes = false;
  private timer: any = null;

  readonly feladatok = [
    { kulcs: 'tagsag', nev: 'Csoporttagság',
      leiras: 'A KRÉTA csoportbesorolásainak letöltése (admin-fiókkal), majd átvétele: új tagok a KRÉTA szerinti belépéstől, '
        + 'a KRÉTÁ-ból kikerültek tagsága tegnappal lezárul. A kézi javítást nem írja vissza.' },
    { kulcs: 'orarend', nev: 'Órarend',
      leiras: 'Minden beállított tanári KRÉTA-belépéssel összeveti és átveszi az órarendet a horizontig, legfeljebb az '
        + 'átvételi határig: 07:00 előtt indulva mától, később holnaptól. Múltbeli és aznap már folyó órához nem nyúl.' },
    { kulcs: 'tanuloadat', nev: 'Tanulói törzsadatok',
      leiras: 'A tanulói adatlapok letöltése (admin-fiókkal), majd átvétele: naplósorszám, törzslapszám, beírási napló sorszáma, '
        + 'igazolványok (diákigazolvány, személyi, TAJ), címek és az egyéni munkarend időszaka. Csak kitölt vagy felülír, '
        + 'sosem töröl; minden írás naplózva.' },
  ];

  constructor(private http: HttpClient, private toast: ToastController) {}

  ngOnChanges() {
    if (!this.intezmeny) return;
    this.betolt();
    if (!this.timer) this.timer = setInterval(() => { if (this.adat?.fut) this.betolt(true); }, 5000);
  }
  ngOnDestroy() { if (this.timer) { clearInterval(this.timer); this.timer = null; } }

  async betolt(csendes = false) {
    try {
      const voltFut = !!this.adat?.fut;
      this.adat = await this.http.get<any>(`${this.base}/allapot/${this.intezmeny}`).toPromise();
      this.hiba = '';
      if (!csendes || (voltFut && !this.adat?.fut)) {
        const b = this.adat?.beallitas || {};
        this.form = {
          tagsag_enabled: !!b.tagsag_enabled, orarend_enabled: !!b.orarend_enabled, tanuloadat_enabled: !!b.tanuloadat_enabled,
          idopontok: (b.idopontok || []).join(', '), horizont_nap: b.horizont_nap || 14,
          atvetel_hatar: b.atvetel_hatar || '', admin_allomany: b.admin_allomany || '',
        };
      }
    } catch (e: any) {
      this.hiba = e?.status === 403 ? 'Az automatikus KRÉTA-szinkront csak adminisztrátor kezelheti.'
        : (e?.error?.error || 'Az állapot nem tölthető be.');
    }
  }

  async ment() {
    this.mentes = true;
    try {
      await this.http.put(`${this.base}/beallitas/${this.intezmeny}`, {
        tagsag_enabled: this.form.tagsag_enabled ? 1 : 0,
        orarend_enabled: this.form.orarend_enabled ? 1 : 0,
        tanuloadat_enabled: this.form.tanuloadat_enabled ? 1 : 0,
        idopontok: this.form.idopontok,
        horizont_nap: this.form.horizont_nap,
        atvetel_hatar: this.form.atvetel_hatar || '',
        admin_allomany: this.form.admin_allomany || '',
      }).toPromise();
      this.uzen('Mentve. A bekapcsolt feladatok a következő időponttól futnak.', 'success');
      await this.betolt();
    } catch (e: any) {
      this.uzen(e?.error?.error || 'Mentési hiba.', 'danger');
    } finally { this.mentes = false; }
  }

  async futtat(feladat: string, nev: string) {
    const kerdes = feladat === 'orarend'
      ? `Az órarend átvétele most elindul minden beállított kollégára (${this.adat?.orarend_idoszak
        ? `${this.adat.orarend_idoszak.tol} – ${this.adat.orarend_idoszak.ig}` : 'nincs átvehető időszak'}).\n\n`
        + 'Ez a Sulinform órarendjét írja, és akár egy óráig is tarthat. Indítod?'
      : feladat === 'tanuloadat'
        ? 'A tanulói törzsadatok letöltése és átvétele most elindul.\n\n'
          + 'Ez a tanulók adatlapját írja (sorszámok, igazolványok, címek, egyéni munkarend) – csak kitölt vagy felülír. Indítod?'
        : 'A KRÉTA csoporttagság letöltése és átvétele (lezárással) most elindul.\n\n'
          + 'Ez a Sulinform csoport-névsorait írja. A kézi javítások („KRÉTA-ban átvezetendő”) védettek. Indítod?';
    if (!confirm(kerdes)) return;
    try {
      await this.http.post(`${this.base}/futtat/${this.intezmeny}`, { feladat }).toPromise();
      this.uzen(`${nev}: elindult a háttérben.`, 'success');
      setTimeout(() => this.betolt(true), 1500);
    } catch (e: any) {
      this.uzen(e?.error?.error || 'Nem indult el.', 'danger');
    }
  }

  async kivetelTorol(k: any) {
    if (!confirm(`${k.tanulo_nev || k.tanulo} · ${k.csoport_nev || k.csoport}\n\n`
      + 'A tételt levesszük a listáról: a következő átvétel ettől kezdve a KRÉTA szerint jár el '
      + (k.irany === 'bent' ? '(ha a KRÉTÁ-ban nincs a csoportban, a tagsága lezárul).' : '(ha a KRÉTÁ-ban a csoportban van, újra felvesszük).')
      + '\n\nFolytatod?')) return;
    try {
      await this.http.delete(`${this.base}/kivetel/${k.id}/${this.intezmeny}`).toPromise();
      this.uzen('Levéve a listáról.', 'success');
      await this.betolt(true);
    } catch (e: any) {
      this.uzen(e?.error?.error || 'Nem sikerült.', 'danger');
    }
  }

  utolso(feladat: string): any { return (this.adat?.futasok?.[feladat] || [])[0] || null; }
  elozmenyek(feladat: string): any[] { return (this.adat?.futasok?.[feladat] || []).slice(1); }

  allapotSzin(a: string): string {
    return a === 'kesz' ? 'success' : a === 'figyelem' ? 'warning' : a === 'fut' ? 'primary' : a === 'kihagyva' ? 'medium' : 'danger';
  }
  allapotNev(a: string): string {
    return ({ kesz: 'rendben', figyelem: 'figyelmeztetés', fut: 'fut', kihagyva: 'kihagyva', hiba: 'hiba' } as any)[a] || a;
  }
  get tobbiLista(): any[] { return this.adat?.tobbi ? Object.values(this.adat.tobbi) : []; }
  fiokNev(f: any): string { return `${f.tanar_nev || f.allomany} (${f.kreta_user})`; }

  private async uzen(m: string, color: string) {
    (await this.toast.create({ message: m, duration: m.length > 90 ? 9000 : 2800, color,
                               buttons: [{ text: 'Bezár', role: 'cancel' }] })).present();
  }
}
